<template>
  <div
    :class="
      hideNumberFieldArrows
        ? 'custom-input container-' + uniqueKey
        : 'default-input container-' + uniqueKey
    "
  >
    <md-field
      :md-counter="false"
      :md-inline="(!label && !label.length) || !value"
      :md-toggle-password="passwordIcon"
      :md-clearable="clearable"
      :class="{ 'md-invalid': invalid }"
    >
      <label v-if="!placeholder || value"
        >{{ label }}
        <template v-if="showRequiredAsterisk"
          ><span class="default-asterisk">*</span></template
        ></label
      >
      <md-input
        :class="{
          'cursor-stop': maxlength && value && value.length >= maxlength,
        }"
        :placeholder="placeholder"
        :type="type"
        :value="dataModelClone"
        @input="handleEmit"
        :required="required"
        :disabled="disabled"
        :maxlength="maxlength"
        :readonly="readOnly"
        onkeydown="return type == 'number' ? event.keyCode !== 69:''"
        @blur="onBlur"
        @focus="onFocus"
        spellcheck="false"
      />

      <b-spinner
        v-if="isLoading"
        variant="secondary"
        role="status"
        size="sm"
        class="vp-input-wizard-spinner"
      />

    </md-field>
    <span class="md-error vp-pl-2 vp-mt-10" v-if="invalid">{{ errMsg }}</span>

    <!-- <div v-if="!!notes.length" class="notes" :class="{ 'vp-mt-30': invalid }">
      <p v-for="(note, noteIndex) in notes" :key="noteIndex">
        {{ note }}
      </p>
    </div> -->
  </div>
</template>

<script>
import "vue-material/dist/theme/default.css";
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";
export default {
  data() {
    return {
      uniqueKey: this.randomString(10),
      container: null,
      dataModelClone: null,
    };
  },
  mixins: [randomStringMixin],
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: Boolean,
      default: false,
    },
    passwordIcon: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errMsg: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    /* ------ Placeholder props ------ */
    placeholder: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    rightPosition: {
      type: String,
      default: "95",
    },
    showRequiredAsterisk: {
      type: Boolean,
      default: false,
    },
    /* ------ Container props ------ */
    width: {
      type: String,
      default: "422",
    },
    height: {
      type: String,
      default: "40px",
    },
    backgroundColor: {
      type: String,
      default: "#f2f2f2",
    },

    /* ------ Input props ------ */
    fontSize: {
      type: String,
      default: "16px",
    },
    fontWeight: {
      type: String,
      default: "700",
    },
    fontColor: {
      type: String,
      default: "#000000de",
    },

    /* ------ Label props ------ */
    label: {
      type: String,
      default: "",
    },
    labelFontSize: {
      type: String,
      default: "12px",
    },
    labelFontWeight: {
      type: String,
      default: "700",
    },
    labelColor: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    hideNumberFieldArrows: {
      type: Boolean,
      default: true,
    },

    /* ------ Note props ------ */
    notes: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.dataModelClone = this.value;

    //Selectors
    this.container = document.querySelector(
      `.container-${this.uniqueKey} .md-theme-default`
    );
    const label = document.querySelector(`.container-${this.uniqueKey} label`);
    const input = document.querySelector(
      `.container-${this.uniqueKey} .md-input`
    );

    //Container styles
    if (this.container) {
      this.container?.style.setProperty('width',`${this.width}px`,'important')
      this.container.style.backgroundColor = this.backgroundColor;
    }

    //Label styles
    if (label) {
      label.style.fontSize = this.labelFontSize;
      label.style.color = this.labelColor;
      label.style.fontWeight = this.labelFontWeight;
    }

    //Input styles
    if (input) {
      input.style.height = this.height;
      input.style.fontSize = this.fontSize;
      input.style.fontWeight = this.fontWeight;
      input.style.fontWeight = this.fontColor;
    }

    this.setBackgroundOnDisabled();
  },
  methods: {
    onBlur() {
      this.$emit("blur");
    },
    onFocus() {
      this.$emit("focus");
    },
    handleEmit(value) {
      if (this.type == "number" && !!this.maxlength) {
        this.$nextTick(() => {
          if (this.value?.length > this.maxlength)
            this.dataModelClone = this.dataModelClone.substring(
              0,
              this.maxlength
            );
        });
      }
      this.$emit("input", value);
    },
    setBackgroundOnDisabled() {
      this.container = document.querySelector(
        `.container-${this.uniqueKey} .md-theme-default`
      );
      const input = document.querySelector(
        `.container-${this.uniqueKey} .md-input`
      );

      const label = document.querySelector(
        `.container-${this.uniqueKey} label`
      );

      if (this.disabled) {
        input?.style.setProperty("opacity", "0.4", "important");
        label?.style.setProperty("opacity", "0.4", "important");
      } else {
        input?.style.setProperty("opacity", "1", "important");
        label?.style.setProperty("opacity", "1", "important");
      }
    },
    setWidth() {
      this.container = document.querySelector(
        `.container-${this.uniqueKey} .md-theme-default`
      );
      this.container.style.width = this.width + "px";
    },
  },
  watch: {
    value() {
      this.dataModelClone = this.value;
    },
    disabled() {
      this.setBackgroundOnDisabled();
    },
    width() {
      this.setWidth();
    },
    rightPosition: {
      handler(val) {
        // add CSS to position asterik according to label
        const styleElement = document.createElement("style");
        const cssRule = `
            .right-${val}:after {
              content: '*';
              color: #f46a6a !important;
              position: absolute;
          }
        `;

        styleElement.appendChild(document.createTextNode(cssRule));
        document.head.appendChild(styleElement);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-input {
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

div[class*="container-"] {
  .md-field.md-required label:after {
    top: 7px;
  }
  .invalid-input {
    color: #f46a6a;
  }

  .md-error {
    position: static;
    // background-color: black;
    height: fit-content !important;
    width: 400px !important;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0.25px;
    // text-align: start;
    color: #f46a6a !important;
    // bottom: -25px !important;
    margin-inline-start: 16px;
    box-decoration-break: clone;
  }
  .md-field.md-theme-default {
    border-radius: 4px;
    label {
      top: 18px;
      font-weight: 400 !important;
      font-size: 16px !important;
      color: #787878;
    }
    label,
    .md-input {
      padding-inline-start: 12px !important;
      margin-inline-start: 5px !important;
      left: unset !important;
    }
  }
  .md-field.md-theme-default.md-focused,
  .md-field.md-theme-default.md-has-value {
    label {
      font-weight: 700 !important;
      font-size: 12px !important;
      top: 0 !important;
      color: #103f5e;
      padding-top: 6px;
      line-height: 17px;
    }
    .md-input {
      -webkit-text-fill-color: #4a4a4a !important;
      line-height: 17px;
    }
  }

  .md-inline {
    .md-input {
      padding-bottom: 0.625rem;
      line-height: 17px;
    }
  }
  .cursor-stop {
    cursor: not-allowed;
  }

  .md-has-password {
    padding-inline-end: 45px !important;
  }
}
</style>

<style lang="scss">
  div[class*="container-"] {
  caret-color: #000 !important;
  .md-has-value {
    .md-input {
      line-height: 16px;
    }
  }
  .md-field {
    margin: unset;
  }
  .md-button.md-icon-button {
    margin-inline-end: 5px;
  }
  input.mx-input::placeholder {
    font-size: 16px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }
  .input-group {
    display: flex;
    flex-direction: row;
    flex-basis: fit-content;
    position: relative;
  }
  input.mx-input {
    font-size: 16px !important;
    // font-weight: 700 !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    text-align: start;
  }
  .md-field.md-theme-default:after,
  .md-field.md-theme-default:before {
    display: none;
  }
  .md-input::placeholder {
    font-weight: 400 !important;
    color: #787878 !important;
  }
  .md-invalid {
    border: 1px solid #f46a6a;
    max-height: 56px;
  }
  .md-focused .required-asterisk {
    color: #103f5e;
  }
  :read-only {
    cursor: default;
  }
  .vp-input-wizard-spinner {
    position: absolute;
    top: 26%;
    inset-inline-end: 2%;
    z-index: 1;
    border-right-color: #d9d9d9;
    margin-inline-end: 15px;
    width: 25px;
    height: 25px;
  }
}

.default-asterisk {
  color: #f46a6a !important;
}
</style>
